import React, { VFC } from 'react'
import { CheckoutLoadingPage, CheckoutLoadingPageProps } from '../checkout/CheckoutLoadingPage'

export type LoadingPageProps = CheckoutLoadingPageProps

// TODO update to standard loading page when available
export const LoadingPage: VFC = ({ ...props }) => {
  return <CheckoutLoadingPage {...props} />
}
